import script from "./TaskCardBottom.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskCardBottom.vue?vue&type=script&setup=true&lang=js"

import "./TaskCardBottom.vue?vue&type=style&index=0&id=0a8f278a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a8f278a"]])

export default __exports__